export default __webpack_public_path__ + "static/media/folder-open.31f8bcb9.svg";